function SelectionFiltersNq() {
    return {
        startDate: null,
        endDate: null,
        questions: [],
        regionId: null,
        subSurveyId: null
      }
}
export default SelectionFiltersNq;